import './index.scss';

import React, { Component } from 'react';
import { SessionStorage } from '../../burger-king-lib/utils/storage.web';
import { LocalSessionKey } from '../../burger-king-lib/constants/app-constants';
class CountButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noService: false,
      showAlert: false,
      outlet: {}
    };
  }

  componentDidMount = () => {
    const outletId = SessionStorage.get(LocalSessionKey.OUTLET_ID);
    const outletStatus = SessionStorage.get('Store_Status') || {};
    if (outletStatus && outletStatus.status) {
      this.setState({ outlet: outletStatus });
    }
    if (outletId === 32236 || (outletStatus && outletStatus.status)) {
      this.setState({ noService: true });
    }
  };

  showModal = () => {
    this.setState({ showAlert: true });
  };

  closeAlertModal = () => {
    this.setState({ showAlert: false });
  };

  render() {
    const {
      content,
      countClick,
      theme,
      size,
      quantity,
      customClass,
      disabled,
      handleDecrement,
      index,
      entire,
      setStat,
      handleIncrement,
      count,
      pIndex
    } = this.props;
    return (
      <>
        <div className="circle-button-container">
          <div
            className="circle"
            role="presentation"
            onClick={() => {
              if (handleDecrement)
                handleDecrement(index, false, pIndex, entire);
            }}
          >
            <button className="circle-button">-</button>
          </div>
          <div className="count">{content}</div>
          <div
            className={`${
              this.props?.entireData?.[0]?.max === quantity
                ? 'grey-class-border'
                : ''
            } circle`}
            role="presentation"
            onClick={() => {
              if (handleIncrement) handleIncrement(index, true, pIndex, entire);
            }}
          >
            <button
              className={`${
                this.props?.entireData?.[0]?.max === quantity
                  ? 'grey-class'
                  : ''
              } circle-button`}
            >
              +
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default CountButton;
